import { useEffect } from "react";

const DEFAULT_DISABLE_DURATION = 330;
const root = document.getElementById("root");

const blockScroll = () => {
  if (!root) return;
  const scrollbarWidth =
    window.innerWidth - document.documentElement.clientWidth;
  root.style.top = `-${window.scrollY}px`;
  root.classList.add("overflow-hidden!");
  if (scrollbarWidth) root.classList.add("md:pr-[15px]");
};

export const unblockScroll = () => {
  if (!root) return;
  const scrollY = root.style.top;
  root.classList.remove("overflow-hidden!", "md:pr-[15px]");
  root.style.top = "0px";
  window.scrollTo({ top: parseInt(scrollY || "0") * -1 });
};

export const useBlockScroll = (
  open: boolean,
  disableDuration?: number,
  shouldBlockScroll: boolean = true,
) => {
  useEffect(() => {
    if (!shouldBlockScroll) return;
    if (open) {
      blockScroll();
    } else {
      setTimeout(
        () => {
          unblockScroll();
        },
        disableDuration ? disableDuration : DEFAULT_DISABLE_DURATION,
      );
    }
  }, [open]);
};
